import CrudTab from 'react/containers/pages/CrudTab';
import { fixGridAndFilterBuilder } from 'react/utils/utils';

class SmartGeocode extends CrudTab {
  static tabName = 'SmartGeocode.title';

  isMassive = false;

  goToRouter = () => {
    try {
      const { tab: { pathname } } = this.props;
      const featureState = Monet.Session.ApplicationLoad.featureStates.filter(obj => obj.name=="MASSIVE_SMART_GEOCODE")[0];
      this.isMassive = featureState && featureState.enabled;
      if (this.isMassive) {
        let router;
        if(App?.Objects?.MassiveSmartGeocode) {
          router = App.Objects.MassiveSmartGeocode;
        } else {
          router = new App.Routers.MassiveSmartGeocode();
          App.Objects.MassiveSmartGeocode = router;
        }

        router.goToScreen();
      } else {
        const [locationId] = pathname.split('/').slice(2);
        const router = new App.Routers.SmartGeocode();

        if (locationId) {
          router.showDetailSmartGeocode(locationId);
        } else {
          router.list();
        }
      }
      
    } catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    this.goToRouter();
  }

  componentDidUpdate(prevProps) {
    const { tab: { pathname }, active } = this.props;
    const hasChanged = pathname !== prevProps.tab.pathname;
    const isComingFromAnotherTab = active !== prevProps.active;
    const grid = App.Forms.MassiveSmartGeocode.table;

    if (isComingFromAnotherTab && grid) {
      grid.resizeCanvas();
      grid.invalidate();
      fixGridAndFilterBuilder();
    }
    

    if (hasChanged && !this.isMassive) {
      this.goToRouter();
    }
    
  }

}

export default SmartGeocode;
